// Is the primary pointer a finger? Drives hit-target sizing (and, later,
// which editor shell renders). SSR-safe: the server has no pointer, so
// it renders the fine-pointer layout and the client corrects on mount —
// the only thing that changes is the size of a few handles.
import { useEffect, useState } from "react";

const COARSE = "(pointer: coarse)";

/** The compact shell: a finger AND not much room. Both halves matter —
 *  a touchscreen laptop has the width for the full toolbar, and a narrow
 *  desktop window still has a mouse, so neither test alone picks the
 *  right chrome. */
const COMPACT = "(pointer: coarse) and (max-width: 900px)";

function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia(query);
    setMatches(mq.matches);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}

export function useCoarsePointer(): boolean {
  return useMediaQuery(COARSE);
}

export function useCompactShell(): boolean {
  return useMediaQuery(COMPACT);
}
